export default [
    '当前医项目仅限专业认证用户加入，您在专业认证时提供的资料有误，需重新上传您的执业资格证、工作证、胸牌、钉钉等工作证明（四选一），需要体现单位、姓名、职务。',
    '当前医项目仅限专业认证用户加入，您在专业认证时提供的资料有误，需重新上传您的名片、胸牌、钉钉等工作证明（三选一），需要体现单位、姓名、职务。',
    '当前医项目仅限专业认证用户加入，您在专业认证时提供的资料有误，需重新上传您的学生证。',
    '当前医项目仅限专业认证用户加入，您在专业认证时提供的资料有误，请填写您的真实姓名。',
    '当前医项目仅限专业认证用户加入，您在专业认证时提供的资料有误，真实姓名与认证照片中的姓名不一致。',
    '当前医项目仅限专业认证用户加入，您上传的专业认证照片不清晰，需上传清晰可辨度高的认证照片。',
    '当前医项目仅限专业认证用户加入，您的专业认证个人资料中，单位名称与认证照片中的单位名称不一致。',
    '当前医项目仅限医疗机构专业认证用户加入。',
];
